



























import { Component, Vue } from 'vue-property-decorator';
import store from '@/store';
import config from '@/config';
import axios from 'axios';
import { AxiosResponse } from 'axios';
import { parseString } from 'xml2js';
import Result from '@/models/results/result';
import 'open-iconic/font/css/open-iconic.css';

@Component({
  components: {
  },
})
export default class ResultsList extends Vue { 

  public results: Result[] = [];

  protected async mounted() {
    store.dispatch('MissionAnimation/UpdateLoading', true);
    this.results = [];
    const uri = `${config.resultsListUrl}`;
    const response = await axios.get(uri, {
      headers: {
        Accept: 'application/xml'
      }
    }) as AxiosResponse<string>;
    parseString(response.data, (error, result) => {
      console.log('error', error);
      console.log('result', result);
      for (const blob of result.EnumerationResults.Blobs[0].Blob) {
        console.log('blob', blob);
        const result: Result = {
          name: blob.Name[0],
          createdAt: blob.Properties[0]['Last-Modified'][0],
          url: blob.Url[0],
          urlBase64: btoa(blob.Url[0])
        };

        this.results.push(result);
      }
      store.dispatch('MissionAnimation/UpdateLoading', false);
    });
    
  }
}

